import { UserConfiguration } from "../model/models";

export class SettingsService {
  private static _birthdayReminderKey = "birthday_reminder";
  private static _userConfigurationKey = "user_configuration";

  public getBirthdayReminderActive(): boolean {
    if (!this.settingExists(SettingsService._birthdayReminderKey)) {
      this.setBirthdayReminderActive(true);
    }
    return this.getBooleanSetting(SettingsService._birthdayReminderKey);
  }

  public setBirthdayReminderActive(value: boolean) {
    this.setBooloeanSetting(SettingsService._birthdayReminderKey, value);
  }

  public getBooleanSetting(key: string): boolean {
    return this.settingExists(key) ? this.getSetting(key).toLowerCase() === "true" : false;
  }

  public setBooloeanSetting(key: string, value: boolean) {
    this.setSetting(key, value.toString());
  }

  public getSetting(key: string): string {
    return localStorage.getItem(key);
  }

  public setSetting(key: string, value: string) {
    localStorage.setItem(key, value);
  }

  public settingExists(key: string): boolean {
    return localStorage.getItem(key) !== null;
  }

  public getUserConfiguration(): UserConfiguration {
    if (!this.settingExists(SettingsService._userConfigurationKey)) {
      const oDefaultConfig: UserConfiguration = {
        experimentalFeaturesEnabled: false,
      };
      this.setUserConfiguration(oDefaultConfig);
    }
    return JSON.parse(this.getSetting(SettingsService._userConfigurationKey));
  }

  public setUserConfiguration(oConfig: UserConfiguration) {
    this.setSetting(SettingsService._userConfigurationKey, JSON.stringify(oConfig));
  }
}
